<template>
  <v-dialog v-model="dialog" max-width="520px" persistent>
    <v-card>
      <v-card-title>Asignar tipo de contrato</v-card-title>
      <v-card-text>
        <div v-if="item" class="mb-4">
          <div class="text-subtitle-1 font-weight-medium">{{ nombreEmpleado }}</div>
          <div class="text-caption grey--text">Código: {{ item.codigo_empleado || '-' }}</div>
          <div class="text-body-2 mt-2"><strong>Puesto:</strong> {{ item.nombre_puesto || '-' }}</div>
          <div class="text-body-2"><strong>Periodo:</strong> {{ periodo }}</div>
        </div>
        <div class="text-body-2 mb-4">Selecciona el tipo de contrato que se asignará a este puesto.</div>
        <v-autocomplete
          v-model="tipoContrato"
          :items="tiposContrato"
          item-value="id_empleado_contrato"
          item-text="nombre"
          label="Tipo de contrato"
          outlined
          dense
          clearable
          :loading="cargandoTipos"
          :disabled="cargandoTipos || guardando"
          hide-details="auto"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="green" text :disabled="guardando" @click="cerrar">Cancelar</v-btn>
        <v-btn color="red" text :loading="guardando" :disabled="!tipoContrato || cargandoTipos" @click="asignar">
          Asignar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-alert-dialog ref="alert" />
  </v-dialog>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue'

export default {
  components: { VAlertDialog },
  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: null }
  },
  data: () => ({
    tiposContrato: [],
    tipoContrato: null,
    cargandoTipos: false,
    guardando: false
  }),
  computed: {
    dialog: {
      get() { return this.value },
      set(value) { this.$emit('input', value) }
    },
    nombreEmpleado() {
      return [this.item && this.item.nombre, this.item && this.item.apellido_paterno, this.item && this.item.apellido_materno]
        .filter(Boolean)
        .join(' ') || 'Empleado sin nombre'
    },
    periodo() {
      if (!this.item) return '-'
      return `${this.item.fecha_desde || this.item.desde_puesto || '-'} a ${this.item.fecha_hasta || this.item.hasta_puesto || 'Vigente'}`
    }
  },
  watch: {
    value(abierto) {
      if (abierto) this.cargarTipos()
      else this.limpiar()
    }
  },
  methods: {
    async cargarTipos() {
      if (!this.item || !this.item.id_empleado_puesto) return
      this.tipoContrato = null
      this.tiposContrato = []
      this.cargandoTipos = true
      try {
        const response = await axios.get(`/RecursosHumanos/ListarCatalogoEmpleadoContratos/${this.item.id_empleado_puesto}`)
        this.tiposContrato = response.data || []
      } catch (error) {
        const data = error && error.response && error.response.data
        const message = data && data.msg ? data.msg.replace('Error : ', '') : 'No se pudieron obtener los tipos de contrato.'
        this.mostrarAlerta(message)
      } finally {
        this.cargandoTipos = false
      }
    },
    async asignar() {
      if (!this.item || !this.item.id_empleado_puesto || !this.tipoContrato) return
      this.guardando = true
      try {
        await axios.post('/RecursosHumanos/AsignarEmpleadoContrato', {
          id_empleado_puesto: this.item.id_empleado_puesto,
          id_empleado_contrato: this.tipoContrato
        })
        this.$emit('assigned', this.item)
        this.cerrar()
      } catch (error) {
        const data = error && error.response && error.response.data
        const message = data && data.msg ? data.msg.replace('Error : ', '') : 'No se pudo asignar el tipo de contrato.'
        this.mostrarAlerta(message)
      } finally {
        this.guardando = false
      }
    },
    cerrar() {
      this.dialog = false
    },
    limpiar() {
      this.tipoContrato = null
      this.tiposContrato = []
    },
    mostrarAlerta(message) {
      this.$refs.alert.setMessage('', message)
      this.$refs.alert.open()
    }
  }
}
</script>
